import React from 'react';

import { Button } from '@mui/material';
import { FallbackProps } from 'react-error-boundary';

import classes from './ErrorFallback.module.scss';
import errorFallbackImg from '../../assets/image/errorFallbackImg.png';
import { goToHomePageWithReload } from '../../utils/windowUtils';
import { logout } from '../../utils/userInfoUtils/logout/logout';

const ErrorFallback = ({ error }: Pick<FallbackProps, 'error'>) => {
  return (
    <div className={classes.box}>
      <img src={errorFallbackImg} alt="error img" />
      <div className={classes.textBox}>
        <h3>Oops! It looks like something goes wrong.</h3>
        <p>Problem: {error.message}</p>
        <p>
          If the page isn&apos;t working as expected, try refreshing page, going back to
          the homepage, or logging out and signing in again to restore access.
        </p>
      </div>
      <div className={classes.buttonBox}>
        <Button variant="outlined" onClick={() => logout()}>
          Log out
        </Button>
        <Button variant="contained" onClick={goToHomePageWithReload}>
          Return to the home page
        </Button>
      </div>
    </div>
  );
};

export { ErrorFallback };
